<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">{{ 'ChangePassWord' | translate}}</h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-right">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
        <mat-card-content class="mat-mdc-card-content text-right">
            <form [formGroup]="form">
                <div class="align-items-right inputTxt">
                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <mat-label>{{ 'CurrentPassword' | translate }} </mat-label>
                        <input matInput class="inputTxt" placeholder="{{ 'CurrentPassword' | translate }} "
                            formControlName="CurrentPassword" maxlength="50" />
                        <mat-icon matPrefix class="op-5 inputTxt">
                            <i-tabler name="lock" class="icon-20 d-flex"></i-tabler>
                        </mat-icon>

                        @if(f['CurrentPassword'].touched && f['CurrentPassword'].invalid)
                        {
                        <mat-hint class="m-b-16 error-msg">
                            @if(f['CurrentPassword'].errors && f['CurrentPassword'].errors['required'])
                            {
                            <div class="text-error"> {{ 'EnterCurrentPassword' | translate }}</div>
                            }
                        </mat-hint>
                        }
                    </mat-form-field>
                </div>
                <div class="align-items-right inputTxt">
                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <mat-label>{{ 'NewPassword' | translate }}</mat-label>
                        <input matInput class="inputTxt" placeholder="{{ 'NewPassword' | translate }}"
                            formControlName="NewPassword" maxlength="50" />
                        <mat-icon matPrefix class="op-5 inputTxt">
                            <i-tabler name="lock" class="icon-20 d-flex"></i-tabler>
                        </mat-icon>

                        @if(f['NewPassword'].touched && f['NewPassword'].invalid)
                        {
                        <mat-hint class="m-b-16 error-msg">
                            @if(f['NewPassword'].errors && f['NewPassword'].errors['required'])
                            {
                            <div class="text-error"> {{ 'EnteNewPassword' | translate }}</div>
                            }
                        </mat-hint>
                        }
                    </mat-form-field>
                </div>

                <mat-divider></mat-divider>

                <div class="row m-t-24">
                    <div class="col-sm-12 text-left">
                        <a (click)="Cancel()" class="Cancelbtn">
                            {{ 'Cancel' | translate}}
                        </a>

                        <button mat-flat-button color="primary" class="orangSavebtn" (click)="Save()">
                            {{ 'Save' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>